import PropTypes from 'prop-types';
import React from 'react';
import s from './WorkTracker.module.scss';
import { taskShape } from './propTypes';
import { summarize } from './lib/summary';

export default function SummaryStrip({ tasks, today }) {
  const segments = summarize(tasks, today);
  if (segments.length === 0) return null;
  return (
    <div className={s.summary} aria-live="polite">
      {segments.map((seg, i) => (
        <React.Fragment key={seg.key}>
          {i > 0 && <span className={s.summarySep}>·</span>}
          {seg.text
            ? <span className={s.summaryClear}>{seg.text}</span>
            : (
              <span>
                <span className={`${s.count} ${s[`tone-${seg.tone}`]}`}>{seg.count}</span>
                {' '}
                {seg.label}
              </span>
            )}
        </React.Fragment>
      ))}
    </div>
  );
}

SummaryStrip.propTypes = {
  tasks: PropTypes.arrayOf(taskShape).isRequired,
  today: PropTypes.instanceOf(Date).isRequired,
};
